import React from "react";
import styled from "@emotion/styled";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  FormHelperText,
} from "@mui/material";
import { ERROR_HELPERTEXT_STYLES, WARNING_COLOR } from "../utils";

const CustomRadioGroup = styled(RadioGroup)({
  "&.MuiFormGroup-root": {
    flexDirection: "row",
    gap: "10px",
    width: "100%",
    flexWrap: "nowrap",
  },

  // "@media screen and (max-width: 767px)": {
  //   "&.MuiFormGroup-root": {
  //     flexWrap: "wrap",
  //   },
  // },
});

const CustomFormControlLabel = styled(FormControlLabel)({
  "&.MuiFormControlLabel-root": {
    paddingRight: "10px",
    padding: ".3rem 0",
    borderRadius: "5px",
    marginRight: "0",
    marginLeft: "0",
    width: "100%",
    // maxWidth: "100%",
  },

  ".MuiTypography-root": {
    fontFamily: "Montserrat",
    fontSize: "15px",
  },

  //   "&.MuiFormControlLabel-root:focus-within": {
  //     color: "rgb(0, 109, 168)",
  //     border: "1px solid rgb(0, 109, 168)",
  //   },
});

const Checkbox = ({
  value,
  label,
  firstoption,
  secondoption,
  helperText,
  error_text,
  error_state,
  disabled,
  handleChangeFirst,
  handleChangeSecond,
  required,
  name,
  horizontal = false,
}) => {
  return (
    <div className={`checkbox ${horizontal ? "horizontal_checkbox" : ""}`}>
      <label style={{ marginBottom: helperText && "0.75rem" }}>
        {label} {required ? <span>*</span> : ""}
      </label>
      <div className="input_checkbox">
        <CustomRadioGroup>
          <CustomFormControlLabel
            sx={{
              "&.MuiFormControlLabel-root": {
                border: error_state
                  ? `1px solid ${WARNING_COLOR}`
                  : value === firstoption
                  ? "1px solid #8ed1fc"
                  : "1px solid #d9d9d9",
                "&:hover": {
                  border: "1px solid #8ed1fc",
                },
              },
            }}
            value={firstoption}
            control={
              <Radio
                disableRipple
                disableFocusRipple
                disableTouchRipple
                disabled={disabled}
                sx={{
                  "&.Mui-checked": {
                    color: "#8ed1fc",
                  },
                  color: "#d9d9d9",
                  ".MuiSvgIcon-root": { height: "1.25rem" },
                }}
                onChange={handleChangeFirst}
                checked={value === firstoption}
                name={name}
              />
            }
            label={firstoption}
          />
          <CustomFormControlLabel
            value={secondoption}
            sx={{
              "&.MuiFormControlLabel-root": {
                border: error_state
                  ? `1px solid ${WARNING_COLOR}`
                  : value === secondoption
                  ? "1px solid #8ed1fc"
                  : "1px solid #d9d9d9",
                "&:hover": {
                  border: "1px solid #8ed1fc",
                },
              },
            }}
            control={
              <Radio
                disableRipple
                disableFocusRipple
                disableTouchRipple
                disabled={disabled}
                sx={{
                  "&.Mui-checked": {
                    color: "#8ed1fc",
                  },
                  color: "#d9d9d9",
                  ".MuiSvgIcon-root": { height: "1.25rem" },
                }}
                onChange={handleChangeSecond}
                checked={value === secondoption}
                name={name}
              />
            }
            label={secondoption}
          />
        </CustomRadioGroup>
        {error_state && (
          <FormHelperText sx={ERROR_HELPERTEXT_STYLES}>
            {error_text}
          </FormHelperText>
        )}
        {helperText && (
          <FormHelperText
            sx={{
              fontStyle: "italic",
              fontSize: "0.75rem",
              color: "#a0aec0",
              margin: "8px 0",
              lineHeight: "1rem",
              letterSpacing: "0.7px",
              fontFamily: "Montserrat",
            }}
          >
            {helperText}
          </FormHelperText>
        )}
      </div>
    </div>
  );
};

export default Checkbox;
